import { NgComponentOutlet } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { BaseComponent } from '@shared/classes';
import { BisCampaignTabsComponent } from '@shared/components/bis-campaign-tabs/bis-campaign-tabs.component';
import { CampaignTypes } from '@shared/constants';
import {
  ChallengesBisTabs,
  DynamicComponent,
  FaqVariant,
  HelpPage,
  Undefined,
} from '@shared/models';

import { Variant1Component } from './variant1/variant1.component';
import { Variant2Component } from './variant2/variant2.component';

@Component({
  selector: 'b2c-faq',
  styleUrl: './faq-variants.component.scss',
  templateUrl: './faq-variants.component.html',
  imports: [BisCampaignTabsComponent, NgComponentOutlet],
})
export class FaqVariantsComponent extends BaseComponent implements OnInit {
  public activeTab = this.dataService.activeTabs.faq;
  public config: HelpPage = this.loyaltyChallengeConfig.pages.help;
  public tabsConfig: Undefined<ChallengesBisTabs[]> =
    this.loyaltyChallengeConfig.components.bisCampaignTabs;

  public components: DynamicComponent<FaqVariant> = {
    [this.Variants.VARIANT_1]: {
      component: Variant1Component,
      inputs: { config: this.config.faqVariant },
    },
    [this.Variants.VARIANT_2]: {
      component: Variant2Component,
      inputs: { config: this.config.faqVariant },
    },
  };

  ngOnInit(): void {
    this.dataService.syncWalletTab(this.activeTab());
  }

  changeTab(tab: CampaignTypes): void {
    this.dataService.activeTabs.faq.set(tab);
    this.dataService.syncWalletTab(tab);
  }
}
